import React, { Component } from 'react'
import ReactTable from 'react-table';
import { Button } from 'antd';
import { getBulkMessageList } from '../../modules/Api';
import history from '../../modules/History';
import ACL from '../../components/ACL';

class BulkMessages extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }
    componentDidMount() {
        const filter = {
        }

        this.fetchData('filter='+JSON.stringify(filter));
    }
    fetchData = (query = '') => {
        getBulkMessageList(query, (data) => {
            this.setState({
                items: data.data,
                last_page: data.last_page,
                count: data.total,
                pageSize: parseInt(data.per_page, 10) || 15
            });
        });
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}${filterQuery}&sort=${JSON.stringify(sort)}`;

        this.fetchData(query);
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',

            },
            {
                Header: 'متن',
                accessor: 'message',
                Cell: row => (<span title={row.original.message}> {row.original.message} </span>)
            },
            {
                Header: 'تعداد',
                accessor: 'count',
            },
            {
                Header: 'فروشگاه',
                accessor: 'messageable.name',
            },
            {
                Header: 'تاریخ ثبت‌نام از',
                accessor: 'from_date',
                Cell: row => (<div dir="ltr" title={row.original.from_date}> {row.original.from_date} </div>)
            },
            {
                Header: 'تاریخ ثبت‌نام تا',
                accessor: 'to_date',
                Cell: row => (<div dir="ltr" title={row.original.to_date}> {row.original.to_date} </div>)
            },
            {
                Header: 'زمان ارسال',
                accessor: 'created_at',
                Cell: row => (<div dir="ltr" title={row.original.created_at}> {row.original.created_at} </div>)
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ACL component="span" has_permission="bulk-messages_management|bulk-messages_add">
                    <Button type="primary" onClick={() => history.item.push(`/bulk-messages/add`)} style={{marginBottom: 10}}>
                    ارسال پیامک انبوه
                    </Button>
                </ACL>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    filterable={true}
                    sortable={true}
                    onFetchData={state => this.onChange(state)}
                    defaultPageSize={this.state.pageSize}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default BulkMessages;


// WEBPACK FOOTER //
// ./src/containers/BulkMessage/index.js